import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'take',
})
export class TakePipe implements PipeTransform {
  transform(value: any[], take?: number): any[] {
    if (!value || value.length <= 0) return value;
    if (!take) return value;
    return value.slice(0, take);
  }
}
